import { render, staticRenderFns } from "./picMore.vue?vue&type=template&id=43dbfee8&scoped=true"
import script from "./picMore.vue?vue&type=script&lang=js"
export * from "./picMore.vue?vue&type=script&lang=js"
import style0 from "./picMore.vue?vue&type=style&index=0&id=43dbfee8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43dbfee8",
  null
  
)

export default component.exports